<template lang="pug">
  div
    //- v-card-actions(:class="$route.name === 'shop' ? 'isCart' : ''").basket-btn__container.modal-cart
    v-btn(rounded color='#009da5' style="width: 100%;" @click="openBasket").basket-btn.text-capitalize
      v-col.py-2.px-4(:class="animated ? 'animated bounceIn': ''" @animationend="animated = false" cols="auto" style="font-size: 18px; text-align: center;  background: #1F7087")
        | {{totalProducts.toFixed(0)}}
      v-col(cols="auto"  style="text-align: center; padding-top: 2px;").pa-2
        v-icon().mx-2 mdi-cart
      v-col(cols="auto")
        .display-2 Ver canasta
      v-col(:class="animated ? 'animated bounceIn': ''" @animationend="animated = false" cols="auto" style="font-size: 18px; text-align: right; padding-top: 0px;").pa-2
        | $ {{totalPrice | numberFormat}}
</template>

<script>
  export default {
    filters: {
      numberFormat (val) {
        if (val) {
          const fixed = Number.parseFloat(val).toFixed(0)
          return fixed.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        } else return '0'
      },
    },
    props: {
      currentShopId: String,
    },
    data () {
      return {
        totalProducts: 0,
        totalPrice: 0,
        animated: false,
        arrCart: {
          inventory: [],
        },
      }
    },
    computed: {
      cart () {
        return this.$store.getters['pos/getCart']
      },
      isMobile () {
        return window.innerWidth < 1024
      },
    },
    watch: {
      cart: {
        handler (val, old) {
          const vm = this
          vm.arrCart = val.filter(el => el.id === this.currentShopId)[0]
          // console.log(vm.arrCart, val)
          if (!val) {
            // console.log('entre')
            vm.arrCart = {
              inventory: [],
              delivery: 'delivery',
            }
          } else {
            vm.getDataCart()
            vm.animated = true
          }
        },
        deep: true,
      },
    },
    created () {
      const vm = this
      vm.arrCart = vm.cart.filter(el => el.id === vm.currentShopId)[0]
      if (!vm.arrCart) {
        vm.arrCart = {
          inventory: [],
          delivery: 'delivery',
        }
      } else {
        vm.getDataCart()
      }
    },
    methods: {
      getPrice (item) {
        // console.log(item)
        if (item.data.price.wholesale && +item.amount >= +item.data.price.wholesale.amount) {
          if (item.data.price.wholesale.percentage) {
            return item.data.price.sale - ((+item.data.price.sale * (+item.data.price.wholesale.price / 100).toFixed(2)).toFixed(2))
          } else {
            return +item.data.price.sale - +item.data.price.wholesale.price
          }
        } else {
          return +item.data.price.sale
        }
      },
      getDataCart () {
        const vm = this
        // vm.arrCart = vm.$store.getters['pos/getCart'].filter(el => el.id === vm.currentShopId)[0]
        // console.log(vm.currentShopId, vm.arrCart, vm.$store.getters['pos/getCart'])
        vm.totalPrice = 0
        vm.totalProducts = 0
        for (let j = 0; j < vm.arrCart.inventory.length; j++) {
          vm.totalPrice = (parseFloat(vm.totalPrice) + (parseFloat(vm.getPrice(vm.arrCart.inventory[j]))) * (parseFloat(vm.arrCart.inventory[j].amount))).toFixed(0)
          if (vm.arrCart.inventory[j].data.magnitude) {
            vm.totalProducts = parseFloat(vm.totalProducts) + 1
          } else {
            vm.totalProducts = (parseFloat(vm.totalProducts) + (parseFloat(vm.arrCart.inventory[j].amount)))
          }
        }
      },
      openBasket () {
        const vm = this
        // vm.$store.dispatch('dialogs/openDialog', 'paymentWizDialog')
        vm.$emit('openbasket')
      },
    },
  }
</script>
